module.exports = __webpack_public_path__ + "static/media/footer-tendances-active.a47db67b.png";